var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GEMINI_SUMMARY_I18N, GEMINI_SUMMARY_PENDING_VALUE, GeminiSummaryMetricLine, GeminiSummarySlashPair, GeminiSummarySubLabel, GeminiSummaryVsSeparator } from '@web/components/Apps/Gemini/geminiSummaryCards';
import { GeminiSummaryUsageLevelMetric } from '@web/components/Apps/Gemini/geminiUsageLevel';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { SummaryCardLabel, SummaryCardShell } from '@web/components/layout/SummaryCards/SummaryCards';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { GEMINI_USAGE_CATEGORY_TRANSLATION_KEYS } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { GeminiUsageCategoryEnum, InsightTypeEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
var I18N = GEMINI_SUMMARY_I18N;
var APP_NAMES_I18N = 'app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection.tablesData.apps';
var CATEGORY_CARDS = [
    [
        GeminiUsageCategoryEnum.CHAT_AND_RESEARCH,
        GeminiUsageCategoryEnum.CONTENT_CREATION
    ],
    [GeminiUsageCategoryEnum.SUMMARIZE, GeminiUsageCategoryEnum.WORKFLOW_ACTIONS]
];
var categoryLabelKey = function (category) {
    return "".concat(I18N, ".categories.").concat(GEMINI_USAGE_CATEGORY_TRANSLATION_KEYS[category]);
};
var buildCsvRows = function (data, t) {
    var _a, _b, _c, _d;
    var _e, _f, _g, _h, _j, _k, _l, _m;
    var metric = t("".concat(I18N, ".export.metric"));
    var value = t("".concat(I18N, ".export.value"));
    var diff = t("".concat(I18N, ".export.diff"));
    var teamDiff = t("".concat(I18N, ".export.teamDiff"));
    return __spreadArray(__spreadArray([
        (_a = {},
            _a[metric] = t("".concat(I18N, ".geminiInvocations")),
            _a[value] = data.totalActions.count,
            _a[diff] = data.totalActions.prevPeriodDiff.diffString,
            _a[teamDiff] = (_f = (_e = data.totalActions.teamAvgDiff) === null || _e === void 0 ? void 0 : _e.diffString) !== null && _f !== void 0 ? _f : '',
            _a),
        (_b = {},
            _b[metric] = t("".concat(I18N, ".standalone")),
            _b[value] = "".concat(data.standaloneInAppUsage.left.share, "% / ").concat(data.standaloneInAppUsage.left.count),
            _b[diff] = data.standaloneInAppUsage.left.prevPeriodDiff.diffString,
            _b[teamDiff] = (_h = (_g = data.standaloneInAppUsage.left.teamAvgDiff) === null || _g === void 0 ? void 0 : _g.diffString) !== null && _h !== void 0 ? _h : '',
            _b),
        (_c = {},
            _c[metric] = t("".concat(I18N, ".inAppUsage")),
            _c[value] = "".concat(data.standaloneInAppUsage.right.share, "% / ").concat(data.standaloneInAppUsage.right.count),
            _c[diff] = data.standaloneInAppUsage.right.prevPeriodDiff.diffString,
            _c[teamDiff] = (_k = (_j = data.standaloneInAppUsage.right.teamAvgDiff) === null || _j === void 0 ? void 0 : _j.diffString) !== null && _k !== void 0 ? _k : '',
            _c)
    ], CATEGORY_CARDS.flat().map(function (category) {
        var _a;
        var _b, _c;
        var categoryData = data.categories[category];
        return _a = {},
            _a[metric] = t(categoryLabelKey(category)),
            _a[value] = "".concat(categoryData.count, " / ").concat(categoryData.share, "%"),
            _a[diff] = categoryData.prevPeriodDiff.diffString,
            _a[teamDiff] = (_c = (_b = categoryData.teamAvgDiff) === null || _b === void 0 ? void 0 : _b.diffString) !== null && _c !== void 0 ? _c : '',
            _a;
    }), true), [
        (_d = {},
            _d[metric] = t("".concat(I18N, ".topGeminiApp")),
            _d[value] = data.topApp.appName
                ? "".concat(t("".concat(APP_NAMES_I18N, ".").concat(data.topApp.appName)), " / ").concat(data.topApp.count, " / ").concat(data.topApp.share, "%")
                : "".concat(data.topApp.count, " / ").concat(data.topApp.share, "%"),
            _d[diff] = data.topApp.prevPeriodDiff.diffString,
            _d[teamDiff] = (_m = (_l = data.topApp.teamAvgDiff) === null || _l === void 0 ? void 0 : _l.diffString) !== null && _m !== void 0 ? _m : '',
            _d)
    ], false);
};
function GeminiUserSummary(_a) {
    var _this = this;
    var userId = _a.userId;
    var t = useTranslation().t;
    var _b = useFilters(), dateFrom = _b.dateFrom, dateTo = _b.dateTo, orgUnit = _b.orgUnit;
    var _c = trpc.geminiUserSummary.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnit
    }), data = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t("".concat(I18N, ".title")), description: "widgetTitleDescriptions.apps.geminiUserSummary", insightType: InsightTypeEnum.geminiUserSummary, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t("".concat(I18N, ".title")), onExportHandler: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, buildCsvRows(data, t)];
                    }); }); }, disabled: isAiButtonDisabled(data) }) }), _jsxs("div", __assign({ className: "grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-5" }, { children: [_jsxs(SummaryCardShell, __assign({ className: "flex h-full flex-col" }, { children: [_jsx(SummaryCardLabel, __assign({ tooltip: t("".concat(I18N, ".usageLevelTooltip")) }, { children: t("".concat(I18N, ".usageLevel")) })), _jsx(GeminiSummaryUsageLevelMetric, { level: data.usageLevel.level, isPeriodValid: data.usageLevel.period.isValid, prevPeriodDiff: data.usageLevel.previous, t: t }), _jsx(GeminiSummarySubLabel, __assign({ className: "mt-auto pt-2.5" }, { children: t("".concat(I18N, ".geminiInvocations")) })), _jsx(GeminiSummaryMetricLine, { value: String(data.totalActions.count), prevPeriodDiff: data.totalActions.prevPeriodDiff, teamAvgDiff: data.totalActions.teamAvgDiff })] })), _jsxs(SummaryCardShell, __assign({ className: "flex h-full flex-col" }, { children: [_jsx(SummaryCardLabel, __assign({ tooltip: t("".concat(I18N, ".standaloneInAppUsageUserTooltip")) }, { children: t("".concat(I18N, ".standalone")) })), _jsx(GeminiSummarySlashPair, { left: {
                                    value: "".concat(data.standaloneInAppUsage.left.share, "%"),
                                    prevPeriodDiff: data.standaloneInAppUsage.left.prevPeriodDiff,
                                    teamAvgDiff: data.standaloneInAppUsage.left.teamAvgDiff
                                }, right: { value: String(data.standaloneInAppUsage.left.count) } }), _jsxs("div", __assign({ className: "mt-auto" }, { children: [_jsx(GeminiSummaryVsSeparator, { children: t("".concat(I18N, ".vs")) }), _jsx(GeminiSummarySubLabel, __assign({ className: "mt-1.5" }, { children: t("".concat(I18N, ".inAppUsage")) })), _jsx(GeminiSummarySlashPair, { left: {
                                            value: "".concat(data.standaloneInAppUsage.right.share, "%"),
                                            prevPeriodDiff: data.standaloneInAppUsage.right.prevPeriodDiff,
                                            teamAvgDiff: data.standaloneInAppUsage.right.teamAvgDiff
                                        }, right: { value: String(data.standaloneInAppUsage.right.count) } })] }))] })), CATEGORY_CARDS.map(function (categories) { return (_jsxs(SummaryCardShell, __assign({ className: "flex h-full flex-col" }, { children: [_jsx(SummaryCardLabel, __assign({ tooltip: t("".concat(I18N, ".categoryTooltip"), {
                                    category: "".concat(t(categoryLabelKey(categories[0])), " / ").concat(t(categoryLabelKey(categories[1])))
                                }) }, { children: t(categoryLabelKey(categories[0])) })), categories.map(function (category, index) {
                                var categoryData = data.categories[category];
                                return (_jsxs("div", __assign({ className: index > 0 ? 'mt-auto pt-2.5' : undefined }, { children: [index > 0 ? (_jsx(GeminiSummarySubLabel, { children: t(categoryLabelKey(category)) })) : null, _jsx(GeminiSummarySlashPair, { left: {
                                                value: String(categoryData.count),
                                                prevPeriodDiff: categoryData.prevPeriodDiff,
                                                teamAvgDiff: categoryData.teamAvgDiff
                                            }, right: { value: "".concat(categoryData.share, "%") } })] }), category));
                            })] }), categories.join('-'))); }), _jsxs(SummaryCardShell, { children: [_jsx(SummaryCardLabel, __assign({ tooltip: t("".concat(I18N, ".topGeminiAppTooltip")) }, { children: t("".concat(I18N, ".topGeminiApp")) })), _jsx("p", __assign({ className: "mt-1 truncate text-xl font-semibold leading-none tracking-tight text-slate-900" }, { children: data.topApp.appName
                                    ? t("".concat(APP_NAMES_I18N, ".").concat(data.topApp.appName))
                                    : GEMINI_SUMMARY_PENDING_VALUE })), _jsx(GeminiSummarySlashPair, { left: {
                                    value: String(data.topApp.count),
                                    prevPeriodDiff: data.topApp.prevPeriodDiff,
                                    teamAvgDiff: data.topApp.teamAvgDiff
                                }, right: { value: "".concat(data.topApp.share, "%") } })] })] }))] }));
}
export default GeminiUserSummary;
